class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        // console.log("pb_prequalify_init",pb_prequalify_init);
        if(pb_prequalify_init){
          pb_prequalify_init()
          .then(() => {
             setTimeout(() => {
              this.update_paybright();
            },2000);
          })
          .catch((error) => {
            console.error(`Function failed to execute => ${error.message}`);
          });
        }
        

      }).catch(() => {
        
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
        
      });
  }

  update_paybright(){
    var split_html = $('#CartDrawer #paybright-widget-container p').html().split('<img');
    $('#CartDrawer #paybright-widget-container').text('');
    $('#CartDrawer #paybright-widget-container').html('<div class="cont">'+split_html[0]+'</div><div class="pay-bright"><svg xmlns="http://www.w3.org/2000/svg" width="108" height="14" viewBox="0 0 108 14"><g><g><path fill="#4a4af4" d="M12.446 3.174c1.077 0 1.976.456 2.35 1.1v-.58a.283.283 0 0 1 .094-.224.322.322 0 0 1 .239-.087h1.402a.345.345 0 0 1 .238.088.288.288 0 0 1 .096.222v6.605a.29.29 0 0 1-.096.222.331.331 0 0 1-.238.09H15.13a.345.345 0 0 1-.237-.09.306.306 0 0 1-.072-.102.287.287 0 0 1-.023-.12v-.57c-.411.653-1.274 1.098-2.37 1.098C10.42 10.826 8.57 9.335 8.57 7s1.849-3.826 3.876-3.826zm.288 5.848c1.198 0 2.063-.902 2.063-2.033 0-1.131-.865-2.022-2.063-2.022a2.231 2.231 0 0 0-.809.16 2.116 2.116 0 0 0-.68.44 1.961 1.961 0 0 0-.448.65c-.102.243-.15.502-.145.763 0 1.133.909 2.042 2.082 2.042zM8.297 6.98c0 2.332-1.793 3.826-3.832 3.826-.94 0-1.905-.353-2.37-1.006l-.023 3.464v.093a.288.288 0 0 1-.095.221.33.33 0 0 1-.236.09H.33a.346.346 0 0 1-.236-.09.288.288 0 0 1-.095-.221V3.693a.288.288 0 0 1 .095-.221.328.328 0 0 1 .237-.09h1.383a.342.342 0 0 1 .243.086.284.284 0 0 1 .097.225v.58c.45-.643 1.33-1.1 2.426-1.1 2.036 0 3.816 1.474 3.816 3.807zm-2.09 0c0-1.12-.863-2.023-2.06-2.023-.281.001-.559.055-.817.158a2.101 2.101 0 0 0-.686.444c-.195.19-.346.414-.446.66-.1.245-.146.507-.135.77 0 1.131.898 2.033 2.084 2.033 1.197 0 2.06-.922 2.06-2.042zm18.586-3.588c.298 0 .4.177.322.492L22.8 10.612l-.943 2.403-.098.342a.381.381 0 0 1-.145.225.429.429 0 0 1-.266.085H19.84c-.31 0-.399-.175-.288-.465l1.075-2.603h-.553a.45.45 0 0 1-.263-.09.403.403 0 0 1-.148-.22l-2.337-6.43c-.08-.249-.034-.467.331-.467h1.64a.38.38 0 0 1 .231.096.336.336 0 0 1 .11.213l1.619 4.966.964-2.796.654-2.167a.383.383 0 0 1 .145-.226.431.431 0 0 1 .266-.086zm14.019-.124c.177 0 .365.072.365.384v1.294a.335.335 0 0 1-.104.276.383.383 0 0 1-.291.109h-.395c-1.02 0-1.618.486-1.618 1.73v3.237a.287.287 0 0 1-.102.21.324.324 0 0 1-.23.08H35.03a.346.346 0 0 1-.23-.092.289.289 0 0 1-.093-.219V3.662a.284.284 0 0 1 .094-.223.328.328 0 0 1 .24-.088h1.329a.335.335 0 0 1 .23.081c.062.055.098.13.102.21v.683c.184-.32.457-.588.79-.776a2.285 2.285 0 0 1 1.104-.292c.072.01.144.013.216.011zm.577-2.074a1.15 1.15 0 0 1 .22-.665c.143-.196.344-.35.578-.44a1.37 1.37 0 0 1 .741-.065c.248.046.477.16.656.328.18.168.301.382.352.614.05.233.025.474-.071.694-.096.219-.26.407-.47.54a1.348 1.348 0 0 1-1.627-.149 1.174 1.174 0 0 1-.38-.857zm.592 9.385a.355.355 0 0 1-.237-.091.294.294 0 0 1-.099-.221V3.661a.283.283 0 0 1 .094-.223.326.326 0 0 1 .238-.088h1.383a.339.339 0 0 1 .239.088.284.284 0 0 1 .093.223v6.584a.311.311 0 0 1-.1.218.353.353 0 0 1-.232.094h-1.383zM66.418 9.51a.351.351 0 0 1-.058.497c-.509.477-1.295.727-2.182.727-1.263 0-2.559-.643-2.559-2.272V4.983h-1.065a.346.346 0 0 1-.237-.09.3.3 0 0 1-.095-.222v-.994a.292.292 0 0 1 .092-.223.327.327 0 0 1 .235-.094h1.064V1.847a.28.28 0 0 1 .093-.224.337.337 0 0 1 .239-.087h1.407a.342.342 0 0 1 .243.085c.032.03.057.065.073.103.017.04.025.08.024.123V3.34h2.238c.088 0 .172.034.235.092a.303.303 0 0 1 .097.22v.995a.309.309 0 0 1-.1.217.35.35 0 0 1-.232.093h-2.238v3.054c0 .708.519.924.885.924.261-.005.515-.08.732-.216.226-.146.487-.146.62.052zm-17.622.093c-.395.582-1.252 1.027-2.337 1.027-2.118 0-3.902-1.41-3.902-3.734 0-2.323 1.818-3.752 3.823-3.752 1.098 0 2.029.466 2.416 1.098v-.58a.292.292 0 0 1 .096-.222.344.344 0 0 1 .236-.09h1.383a.341.341 0 0 1 .238.089.296.296 0 0 1 .094.223v6.948c0 2-1.58 3.39-4.149 3.39-2.06 0-3.568-1.224-3.933-2.603a.217.217 0 0 1 .001-.188.23.23 0 0 1 .062-.076.248.248 0 0 1 .09-.046h1.52c.197 0 .31.02.365.124.176.54.775 1.1 1.929 1.1 1.412.03 2.068-.675 2.068-1.753zm-2.072-.684c1.197 0 2.062-.85 2.062-1.98s-.865-1.982-2.062-1.982a2.166 2.166 0 0 0-.805.147c-.255.1-.486.247-.679.432a1.901 1.901 0 0 0-.442.646c-.1.241-.145.499-.135.757 0 1.13.875 1.98 2.06 1.98zM30.3 3.122c1.993 0 3.833 1.484 3.833 3.817s-1.83 3.826-3.859 3.826c-1.096 0-1.928-.445-2.37-1.1v.58a.29.29 0 0 1-.096.223.331.331 0 0 1-.236.09H26.19a.344.344 0 0 1-.237-.09.288.288 0 0 1-.095-.223V2.668L25.836.623A.298.298 0 0 1 25.93.4a.323.323 0 0 1 .24-.088h1.382a.354.354 0 0 1 .233.093.31.31 0 0 1 .1.218l.023 2.044V4.19c.387-.6 1.296-1.068 2.394-1.068zm1.762 3.826c.006-.26-.044-.52-.145-.762a1.962 1.962 0 0 0-.448-.65 2.117 2.117 0 0 0-.681-.44 2.232 2.232 0 0 0-.81-.16c-1.175 0-2.06.89-2.06 2.021 0 1.132.885 2.034 2.06 2.034 1.171 0 2.06-.912 2.084-2.043zm24.613-3.826c2.04 0 3.317 1.35 3.28 3.142v4.002a.285.285 0 0 1-.101.21.327.327 0 0 1-.23.082H58.24a.34.34 0 0 1-.23-.081.303.303 0 0 1-.074-.096.284.284 0 0 1-.028-.115V6.784c0-1.139-.675-1.878-1.873-1.878-1.153 0-1.928.758-1.928 1.878v3.482a.296.296 0 0 1-.101.21.337.337 0 0 1-.23.082h-1.409a.346.346 0 0 1-.237-.09.303.303 0 0 1-.095-.222V.634a.29.29 0 0 1 .095-.221.345.345 0 0 1 .237-.09h1.408a.335.335 0 0 1 .23.081c.062.055.1.13.102.21V4.19c.45-.58 1.338-1.068 2.568-1.068zM72.212 5.32h.646V7.25h.054c.108-.211.282-.388.497-.508.216-.12.465-.178.716-.166 1.059 0 1.79.787 1.79 2.022 0 1.235-.731 2.033-1.779 2.033-.253.01-.504-.05-.72-.172a1.248 1.248 0 0 1-.503-.514h-.078v.603h-.623zm1.835 4.772c.808 0 1.223-.665 1.223-1.502 0-.838-.395-1.48-1.223-1.48-.79 0-1.2.594-1.2 1.48 0 .885.426 1.502 1.2 1.502zm2.81 1.318c.47.113.764.056.988-.532l.126-.307-1.55-3.937h.699l1.157 3.126h.044l1.157-3.126h.704l-1.778 4.486c-.241.6-.654.89-1.235.89a1.323 1.323 0 0 1-.476-.07zM84.2 9.854c.597 0 1.023-.48 1.023-1.074-.966.096-1.495.248-1.495.691 0 .239.156.383.472.383zm.409-3.33c1.015 0 1.806.424 1.806 1.48v2.556h-1.12v-.61a1.582 1.582 0 0 1-.591.532 1.713 1.713 0 0 1-.792.194c-.844 0-1.383-.428-1.383-1.138 0-.895.971-1.213 2.212-1.364.332-.04.508-.143.508-.348 0-.301-.265-.45-.745-.45a2.35 2.35 0 0 0-1.41.554l-.396-.777a3.582 3.582 0 0 1 1.919-.626zm12.38.11v.658c.095-.238.268-.442.495-.581.227-.14.495-.207.766-.193.184-.004.367.027.537.09l-.219 1.037a.964.964 0 0 0-.511-.14c-.396 0-.988.262-.988 1.162v1.891h-1.2V6.634zm7.366-.115c.766 0 1.4.446 1.4 1.328v2.711h-1.199V8.205c0-.523-.334-.74-.65-.74-.395 0-.79.335-.79 1.075v2.018h-1.197V8.205c0-.53-.316-.74-.66-.74-.383 0-.791.348-.791 1.075v2.018H99.27V6.634h1.155v.595c.128-.212.313-.39.537-.514a1.56 1.56 0 0 1 1.485-.012c.227.12.415.295.546.506.15-.209.352-.38.587-.5.237-.12.5-.186.769-.19zm-11.401.982h-1.087v3.057h-1.199V7.501h-1.817v3.057h-1.2V7.501h-.693v-.867h.695v-.298c0-1.258.871-1.663 1.638-1.663.368-.012.732.067 1.057.229l-.37.791a1.22 1.22 0 0 0-.537-.126c-.276 0-.593.15-.593.67v.397h1.818v-.298c0-1.258.873-1.663 1.64-1.663.368-.014.733.065 1.057.229l-.372.791a1.253 1.253 0 0 0-.535-.126c-.275 0-.593.15-.593.67v.397h1.087zm.71-.867h1.2v3.924h-1.2zm6.988-5.473c-3.237 0-6.124 2.103-6.942 4.806h1.174c.684-2.015 3.005-3.782 5.768-3.782 3.359 0 6.259 2.392 6.259 6.116a7.176 7.176 0 0 1-.334 2.255h1.138l.012-.037A8.51 8.51 0 0 0 108 8.298c0-4.154-3.234-7.143-7.355-7.143"/></g></g></svg> <a href="javascript:void(0);" class="info"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g><g><path fill="#676870" d="M12 6c0 3.317-2.684 6-6 6-3.317 0-6-2.684-6-6 0-3.317 2.684-6 6-6 3.317 0 6 2.684 6 6zM6.43 8.2a.613.613 0 0 0-.608-.608c-.331 0-.6.276-.6.608 0 .324.26.608.6.608.34 0 .609-.284.609-.608zm1.177-3.91c0-.742-.671-1.302-1.682-1.302-1.066 0-1.556.631-1.556 1.058 0 .308.26.45.474.45.427 0 .253-.608 1.058-.608.395 0 .711.174.711.537 0 .426-.442.671-.703.892-.229.198-.529.522-.529 1.2 0 .412.11.53.435.53.387 0 .465-.174.465-.324 0-.41.008-.647.443-.987.213-.166.884-.703.884-1.445z"/></g></g></svg></a></div><a data-pb_open_modal href="#" class="more"> Learn more</a>');
    var append_html = $('#paybright-widget-container').html();
    $('.intrest-free-payment').append('<div id="paybright-widget-container" class="active">'+append_html+'</div>');
    
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
